export default {
  getChatSession: (state) => state.chatSession,
  getMessages: (state) => state.messages,
};
